{
  "salon-visited-page": {
    "buttons": {
      "book-appointment": "PRENDRE RENDEZ-VOUS"
    },
    "text": {
      "no-visited-salon": "Aucun salon visité ne peut être trouvé",
      "promotional-message": "Message promotionnel",
      "visited-salon": "Visite de salons de coiffure"
    },
    "meta": {
      "title": "Visite de salons de coiffure",
      "description": "Liste des salons visités"
    }
  }
}
